import * as Actions from '../../actions';

const initialState = { data: null };

const listCloseMonthDetails = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_CLOSE_MONTH_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listCloseMonthDetails;
